export function calcRate(currency, rates) {
  if (rates) {
    return currency.fxCode
      ? (currency.peg ? rates[currency.fxCode] * currency.peg : rates[currency.fxCode])
      : rates[currency.code];
  } else return 1
}

export function calcNumFiatCoins(currency, rates) {
  if (rates && rates.USD) {
    const fiatRate = calcRate(currency, rates)
    const coin = currency.coins[0]
    const unit = currency.units[coin.unit]
    const fiatValue = unit.value * coin.units
    return Math.min((0.00000001 * fiatRate) / fiatValue, 1000)
  } else return 1
}

export function formatCurrency (currency, amount) {
  // Support for Intl.NumberFormat not quite there yet for all currencies/locales
  // const format = new Intl.NumberFormat(currency.locale, {currency: currency.code, currencyDisplay: "symbol", style: "currency"})
  // return format.format(amount)
  if (!currency || !currency.symbol || amount == null) return ''

  if (currency.symbol.middle) {
    return amount.toLocaleString(undefined, { minimumFractionDigits: currency.maxDP, maximumFractionDigits: currency.maxDP }).replace('.', currency.symbol.char)
  } else {
    let parts = [currency.symbol.char, amount.toLocaleString(undefined, { minimumFractionDigits: currency.maxDP, maximumFractionDigits: currency.maxDP })]
    if (!currency.symbol.pre) parts = parts.reverse()
    return parts.join(' ')
  }
}

export function formatCurrencyName (currency) {
  const coin = currency.coins[0]
  const unit = currency.units[coin.unit]
  return `${currency.name} (${currency.code}) - ${coin.units} ${coin.units !== 1 ? unit.plural : unit.name}`
}
